<template>
  <div>

     <data-table
        table-ref="requests-table"

        title="Requests"
        icon="fa fa-share-alt"

        hide-org-badge
        :show-search="false"

        :url="'/actions/site/' + rowData.id + '/null/rt'"

        :fields="fields"

        detail-component="requests-detail-row" />

  </div>

</template>


<script>
import Vue from 'vue'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import RequestDetails from '@/components/requests/workflow/RequestWorkflow'


Vue.component('requests-detail-row', RequestDetails)

export default {

  mixins: [DateMixins, NumberMixins],


  components: {
    RequestDetails
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }


  },



  data () {

    return {

      telcoId: this.isTelco() ? Number(this.org().id) : null,
/*
      action: PermitAction,

      addProps: {
        rowData: this.rowData,
        editMode: true,
        readOnly: this.readOnly,
        siteId: this.rowData.id
      },
*/
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'actionType',
          title: 'Type',
        },
        {
          name: 'status',
          title: 'Status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'priority',
          title: 'Priority',
          callback: this.formatPriority,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'organisation.shortName',
          title: 'Company',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'targetDate',
          title: 'Target Date',
          callback: 'formatDate|DD MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
      ]
    }

  }

}

</script>
